<template lang="pug">
    v-btn(
        :loading="busy"
        color="primary"
        @click="exportOrders")
        v-icon(left) cloud_download
        | {{ $t('actions.export') }}
</template>

<script>
import ExportOrders from '@/services/Orders/ExportOrders'

export default {
    props: {
        selectedFilters: Object,
        selectedItems: Array,
    },
    data() {
        return {
            busy: false,
        }
    },
    methods: {
        exportOrders() {
            this.busy = true
            ExportOrders({
                ...{ id: this.selectedItems },
                ...this.selectedFilters,
            }).finally(() => {
                this.busy = false
            })
        },
    },
}
</script>
